import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "nav", "search", "link"]

  connect() {
    this.setupEventListeners()
  }

  setupEventListeners() {
    document.addEventListener('click', this.handleOutsideClick.bind(this))
    document.addEventListener('keydown', this.handleKeydown.bind(this))
  }

  toggle() {
    this.navTarget.classList.contains('opacity-0') ? this.open() : this.close()
  }

  open() {
    this.navTarget.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-4', 'scale-95')
    this.navTarget.classList.add('opacity-100', 'translate-y-0', 'scale-100')
    this.searchTarget.value = ''
    this.searchTarget.focus()
    this.linkTargets.forEach(link => link.classList.remove('hidden'))
  }

  close() {
    this.navTarget.classList.add('opacity-0', 'pointer-events-none', 'translate-y-4', 'scale-95')
    this.navTarget.classList.remove('opacity-100', 'translate-y-0', 'scale-100')
    this.searchTarget.value = ''
    this.searchTarget.blur()
  }

  handleSearch(event) {
    const term = event.target.value.toLowerCase()
    this.linkTargets.forEach(link => {
      const label = link.dataset.label
      const shouldShow = label.includes(term)
      link.classList.toggle('hidden', !shouldShow)
      if (shouldShow) {
        link.style.transitionDelay = `${this.linkTargets.indexOf(link) * 50}ms`
      } else {
        link.style.transitionDelay = '0ms'
      }
    })
  }

  handleLinkClick(event) {
    const id = event.currentTarget.dataset.targetId
    const element = document.getElementById(id)
    if (element) {
      document.querySelectorAll('.highlight-animation').forEach(el => {
        el.classList.remove('highlight-animation', 'active', 'fade-out')
      })

      element.classList.add('highlight-animation')
      requestAnimationFrame(() => {
        element.classList.add('active')
      })

      element.scrollIntoView({ behavior: 'smooth', block: 'center' })

      setTimeout(() => {
        element.classList.add('fade-out')
      }, 1200)

      setTimeout(() => {
        element.classList.remove('highlight-animation', 'active', 'fade-out')
      }, 1700)
    }
    this.close()
  }

  handleOutsideClick(event) {
    if (!this.navTarget.contains(event.target) && !this.toggleTarget.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.close()
    }
    const isMac = navigator.platform.toUpperCase().includes('MAC')
    if ((isMac ? event.metaKey : event.ctrlKey) && event.key.toLowerCase() === 'e') {
      event.preventDefault()
      this.toggle()
    }
  }
} 